export default {
  // 客服資訊
  billList: [],
  billPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: null,
  },
  billModal: {
    billInfo: {},
    driverInfo: {},
    passengerServerInfo: {},
    status: {},
  },
  // 預約單
  reserveList: [],
  reservePaging: {
    currentPage: 1,
    npp: 10,
    totalPages: 1,
    totalEntries: null,
  },
  reserveCount: 0,
  // 叫車紀錄左下角的司機資訊
  driverInfo: {
    info: {
      // car
      brand: '',
      carYear: '',
      carLicense: '',
      carStatus: '',
      // person
      name: '',
      callNumber: '',
      serviceList: '',
      gender: '',
      phone: '',
      note: '',
      updatedAt: '',
      contact1: '',
      contact2: '',
    },
    onGetOrderGps: {},
    onGps: [],
    status: {},
  },
  // 關鍵字
  kw: '',
  // radio選項
  picked: 1,
  task: 'all',
  // 更新時間
  lastUpdateTime: '',
  // 語音switch
  switchSpeech: true,
}



// WEBPACK FOOTER //
// ./src/store/hailState/state.js